<template>
  <div class="contents_wrap">
    <div class="small_title_wrap">
      <h2>발송 정보 [받는 분]</h2>
    </div>
    <ul class="filter_list">
      <li>
        <dd>
          <label>수신<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input type="text"
                     :class="{'error' : errorTarget === 'receiveNm'}"
                     v-model.trim="sendInfo.receiveNm"
                     @input="sendInfo.receiveNm=EtnersCommonUtil.cutByteLength(sendInfo.receiveNm, 100)"
                     placeholder="수신 정보를 입력하세요.">
            </li>
          </ul>
        </dd>
        <dd>
          <label>무게(kg)<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  type="number"
                  class="w100"
                  :class="{'error' : errorTarget === 'weight'}"
                  min="0"
                  v-model="sendInfo.weight"
                  @input="sendInfo.weight=EtnersCommonUtil.cutByteLength(sendInfo.weight, 20)"
                  :placeholder="'무게(kg)를 입력하세요.'"
              >
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수신 주소<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input type="text"
                     class="w80"
                     style="display: inline-flex; border-width: 1px;"
                     :class="{'error' : errorTarget === 'receiveAddr'}"
                     v-model="receiveAddrWithPostNo"
                     :readonly="true"
                     @click="onSearchPostCd"
                     placeholder="주소지 검색">
              <kendo-button
                  style="width:18%;"
                  class="mid_btn ml5"
                  @click="onSearchPostCd"
              > 검색
              </kendo-button>
            </li>
          </ul>
        </dd>
        <dd>
          <label>물품명<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  type="text"
                  :class="{'error' : errorTarget === 'itemNm'}"
                  v-model.trim="sendInfo.itemNm"
                  @input="sendInfo.itemNm=EtnersCommonUtil.cutByteLength(sendInfo.itemNm, 50)"
                  placeholder="물품명을 입력하세요."
              >
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>상세 주소<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  type="text"
                  :class="{'error' : errorTarget === 'receiveAddrDtl'}"
                  v-model.trim="sendInfo.receiveAddrDtl"
                  @input="sendInfo.receiveAddrDtl=EtnersCommonUtil.cutByteLength(sendInfo.receiveAddrDtl, 500)"
                  placeholder="상세 주소를 입력하세요."
              >
            </li>
          </ul>
        </dd>
        <dd>
          <label>신고 금액<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  type="number"
                  class="w100"
                  :class="{'error' : errorTarget === 'regCost'}"
                  min="0"
                  v-model="sendInfo.regCost"
                  @input="sendInfo.regCost=EtnersCommonUtil.cutByteLength(sendInfo.regCost, 50)"
                  :placeholder="'신고 금액을 입력하세요.'"
              >
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수신 연락처<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  type="text"
                  :class="{'error' : errorTarget === 'receiveTel'}"
                  v-model.trim="sendInfo.receiveTel"
                  @input="sendInfo.receiveTel=EtnersCommonUtil.cutByteLength(sendInfo.receiveTel, 20)"
                  :placeholder="'수신 연락처를 입력하세요.'"
              >
            </li>
          </ul>
        </dd>
        <dd>
          <label>수량<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  type="number"
                  class="w100"
                  :class="{'error' : errorTarget === 'qty'}"
                  min="0"
                  v-model="sendInfo.qty"
                  @input="sendInfo.qty=EtnersCommonUtil.cutByteLength(sendInfo.qty, 2)"
                  :placeholder="'수량을 입력하세요'">
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>비고</label>
          <ul class="w50">
            <li>
              <input
                  type="text"
                  :class="{'error' : errorTarget === 'contents'}"
                  v-model.trim="sendInfo.contents"
                  @input="sendInfo.contents=EtnersCommonUtil.cutByteLength(sendInfo.contents, 4000)"
                  :placeholder="'비고를 입력하세요.'"
              >
            </li>
          </ul>
        </dd>
        <dd>
          <label>보관 위치<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  :class="{'error' : errorTarget === 'lockerId'}"
                  ref="lockerIdRef"
                  v-model="sendInfo.lockerId"
                  :data-text-field="'lockerNm'"
                  :data-value-field="'lockerId'"
                  :option-label="'거점 선택 후 선택해주세요.'"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label></label>
          <ul class="w50">
            <li>
            </li>
          </ul>
        </dd>
        <dd>
          <label>무인 보관함 번호</label>
          <ul class="w50">
            <li>
              <input
                  type="text"
                  v-model="sendInfo.lockerCellId"
                  :disabled="true"
                  placeholder="무인 보관함 번호"
              >
            </li>
          </ul>
        </dd>
      </li>
    </ul>
    <daum-postcode-window
        ref="daumPostCodeRef"
        v-on:send-addr-data="getAddrData"
    ></daum-postcode-window>
  </div>
</template>

<script>

import DaumPostcodeWindow from "@/components/DaumPostcodeWindow";
import EtnersCommonUtil from "@/common/etners.common.util";
import EtnersLogisticsUtil from '@/common/etners.logistics.util'

export default {
  name: "SendUpdateRegi",
  components: {DaumPostcodeWindow},
  props: {
    propsSendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
    lockerNmDataSource : {
      type: Array,
      required: false,
      default : function (){
        return []
      }
    }
  },
  watch: {
    'propsSendInfo': {
      handler: function (val, oldVal) {
        this.sendInfo = this.propsSendInfo
      },
      deep: true,
    },
    'lockerNmDataSource': {
      handler: function (val, oldVal) {
        this.$refs.lockerIdRef.kendoWidget().setDataSource(val)
        this.$refs.lockerIdRef.kendoWidget().value(this.sendInfo.lockerId)
        return val
      }
    }
  },
  computed: {
    receiveAddrWithPostNo () {
      const vm = this
      const receivePost = vm.sendInfo.receivePost
      const receiveAddr = vm.sendInfo.receiveAddr

      if(receivePost !== null && receiveAddr !== null){
        return `(${receivePost}) ${receiveAddr}`
      }else{
        return ''
      }
    }
  },
  methods: {
    getPropsSendInfo () {
      // 부모 컴포넌트(SendSave.vue)에서 호출
      const vm = this
      const sendInfo = vm.sendInfo

      // 유효성 검사
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveNm)) {
        kendo.alert('수신을 입력해주세요.')
        vm.errorTarget = 'receiveNm'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.weight)) {
        kendo.alert('무게를 입력해주세요.')
        vm.errorTarget = 'weight'
        return
      } else if (!EtnersCommonUtil.isPositiveInteger(sendInfo.weight)) {
        kendo.alert('무게는 1이상의 숫자를 입력해주세요.')
        vm.errorTarget = 'weight'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveAddr)) {
        kendo.alert('수신 주소를 입력해주세요.')
        vm.errorTarget = 'receiveAddr'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveAddrDtl)) {
        kendo.alert('상세 주소를 입력해주세요.')
        vm.errorTarget = 'receiveAddrDtl'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.itemNm)) {
        kendo.alert('물품명을 입력해주세요.')
        vm.errorTarget = 'itemNm'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.regCost)) {
        kendo.alert('신고 금액을 입력해주세요.')
        vm.errorTarget = 'regCost'
        return
      } else if (!EtnersCommonUtil.isPositiveInteger(sendInfo.regCost)) {
        kendo.alert('신고 금액은 1이상의 숫자를 입력해주세요.')
        vm.errorTarget = 'regCost'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveTel)) {
        kendo.alert('수신 연락처를 입력해주세요.')
        vm.errorTarget = 'receiveTel'
        return
      } else if(!EtnersLogisticsUtil.isTelNum(sendInfo.receiveTel)){
        kendo.alert('수신 연락처를 형식에 맞게 입력해 주세요.')
        vm.errorTarget = 'receiveTel'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.qty)) {
        kendo.alert('수량을 입력해주세요.')
        vm.errorTarget = 'qty'
        return
      } else if (!EtnersCommonUtil.isPositiveInteger(sendInfo.qty)) {
        kendo.alert('수량은 1이상의 숫자를 입력해주세요.')
        vm.errorTarget = 'qty'
        return
      }
      if (!!vm.$refs.lockerIdRef) {
        const lockerId = vm.$refs.lockerIdRef.kendoWidget().value()
        if (EtnersCommonUtil.isEmpty(lockerId)) {
          kendo.alert('보관 위치를 선택해주세요.')
          vm.errorTarget = 'lockerId'
          return
        }
        vm.sendInfo.lockerId = lockerId
      }
      vm.errorTarget = null
      return vm.sendInfo
    },
    onSearchPostCd () {
      const vm = this
      const refs = vm.$refs
      refs.daumPostCodeRef.$refs.daumPostCodeRef.kendoWidget().center().open()
    },
    getAddrData (addrData) {
      const vm = this
      vm.sendInfo.receiveAddr = addrData.addr
      vm.sendInfo.receivePost = addrData.zipCode
    },
  },
  data () {
    const vm = this
    return {
      EtnersCommonUtil: EtnersCommonUtil,
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      sendInfo: {
        ...vm.propsSendInfo,
      },
      addrData : {}, // 주소 검색 컴포넌트 용
      errorTarget: null, // 유효성 체크 error 클래스 활용
    }
  }
}
</script>

<style scoped>

</style>
